import { NettoRateType } from 'app/constants/nettoRateType'

export const getNettoRateTypeName = (
  type: NettoRateType,
  translate: (string) => string,
): string => {
  const text: string = NettoRateType[type]
  return translate(`nettoRateType.${text}`)
}
